// mount the components
SwiftypeComponents.onReady(function() {
  SwiftypeComponents.react.mountAll();
});

$(document).ready(function() {
  // if facets active show facets, results & status
  var url = window.location.href;
  if (url.indexOf("?") > -1) {
    $('#facets-wrapper').show();
    $('#search-results').show();
    $('#search-status').show();
  }

});

// format prices
const searchResultsElement = document.getElementById("search_results");

if (searchResultsElement) {
  // Create a MutationObserver instance
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        // console.log([mutation])
        const newElements = Array.from(mutation.addedNodes).filter(
          (node) => node.classList && node.classList.contains("result")
        );
        // console.log([newElements])
        if (newElements.length > 0) {
          newElements.forEach((element) => {
            formatPrices(); // Call the function for each new element
          });
        }
      }
    }
  });

  // Start observing changes to the #search_results element
  observer.observe(searchResultsElement, {
    childList: true, // Watch for changes in the children of #search_results
    subtree: true,   // Watch for changes in the entire subtree of #search_results
  });
}

function formatPrices() {
  // console.log('test')
  $('.formatPrice').each(function() {
    var x = parseFloat($(this).text(), 10).toFixed(2);
    $(this).html(x);
  });
}

// // infinite scroll
// let resultsPage = 1;
// const currentUrl = window.location.href;
// function loadNextResults() {
//   resultsPage++;
//   const targetResults = `${currentUrl}&page=${resultsPage}`
//   console.log('infinite scrolling baby!', resultsPage, targetResults);
//   $.ajax({
//     url: targetResults,
//     type: 'GET',
//     success: function(data) {
//       var tempElement = $('<div>').html(data);
//       var resultsContent = tempElement.find('#search_results').html();
//       $('#search_results').append(resultsContent);
//     },
//     error: function() {
//       console.error('Error loading content');
//     }
//   });
// }

// function scrolledToBottom(e) {
//   var rect = e[0].getBoundingClientRect();
//   return rect.bottom <= $(window).height();
//   console.log('at bottom', e)
// }

// // Attach a scroll event to the window
// $(window).scroll(function() {
//   let bottom = scrolledToBottom($('#search_results'));
//   console.log("scrolling...", bottom);
//   // Check if the bottom of #search_results is in the viewport
//   if (scrolledToBottom($('#search_results'))) {
//     // Load results when the bottom is in the viewport
//     loadNextResults();
//   }
// });